module.exports = __webpack_public_path__ + "h5/img/master_16.d20783e6.jpg";